import { httpInstance } from '@/clients/http.request';
import { urlReporte } from '@/helpers';

let latestReportRequestId = 0;

export const getReportByEmpresa = async (
   { commit },
   { dias, id_empresa, id_sucursal_interno },
) => {
   const requestId = ++latestReportRequestId;
   const body = { dias };
   if (id_empresa != null && id_empresa !== '') {
      body.id_empresa = id_empresa;
   }
   if (id_sucursal_interno != null && id_sucursal_interno !== '') {
      body.id_sucursal_interno = id_sucursal_interno;
   }

   try {
      const { data } = await httpInstance.post(`${urlReporte}`, body);
      if (requestId !== latestReportRequestId) {
         return null;
      }
      commit('setReport', data);
      return data;
   } catch (error) {
      if (requestId !== latestReportRequestId) {
         return null;
      }
      throw error;
   }
};
